import { render, staticRenderFns } from "./planProfileForm.vue?vue&type=template&id=12781840&"
import script from "./planProfileForm.vue?vue&type=script&lang=js&"
export * from "./planProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./planProfileForm.vue?vue&type=style&index=0&id=12781840&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports